module.exports = __webpack_public_path__ + "img/kverneland_optima_v.adcc41c9.jpg";